import React, { Component } from "react";
import {Container,Button,ModalBody,Modal,Input,Col,Row,} from "reactstrap";
import ErrorTokenMiss from "../ErrorTokenMiss/ErrorTokenMiss";
import LoadingOverlay from "react-loading-overlay";
import RequestManager from "../../singletons/RequestManager";
export default class StockCartItemPrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenMissmatchModalVisible: false,
      tokenErrorMessage: "",
      price: "",
      spinnerLoading: false,
      salePrice: "",
      description: "",
      comments: "",
    };
  }

  componentDidMount() {
    this.setState({
      price: this.props.stock.sku.maximumRetailPrice,
      salePrice: this.props.stock.salePrice,
      description: this.props.stock.sku.description,
    });
  }
  render() {
    let stock = this.props.stock;
    let cartItem = this.props.cartItem;
    // to continue
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container
          fluid
          style={{
            padding: 0,
            margin: 0,
            alignItems: "center",
            // backgroundColor: "#406ccc",
            backgroundColor: "white",
          }}
        >
          <Modal
            size="lg"
            isOpen={this.state.tokenMissmatchModalVisible}
            toggle={this.toggleErrorTokenMissModal}
          >
            <ErrorTokenMiss
              editable={true}
              tokenErrorMessage={this.state.tokenErrorMessage}
              goBack={this.toggleErrorTokenMissModal}
            />
          </Modal>
          <ModalBody>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginBottom: 15,
                  paddingBottom: 10,
                  borderBottom: "1px solid #ECECEC",
                }}
              >
                <p style={{ fontSize: 20, fontWeight: "bold" }}>Product </p>

                <Button
                  style={{ color: "white", backgroundColor: "red" }}
                  onClick={this.props.goBack}
                >
                  {" "}
                  Back
                </Button>
              </div>
              <div style={{ fontSize: 20, fontWeight: "bold" }}>
                <Col
                  xs="12"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                  }}
                >
                  <p>Name</p>
                  <p>
                    <Input
                      style={{
                        padding: 10,
                        marginRight: 10,
                      }}
                      disabled={true}
                      placeholder="Enter name"
                      value={
                        stock.sku.quantity === null
                          ? stock.sku.name +
                            " - " +
                            stock.referenceName
                          : stock.sku.name +
                            " - " +
                            stock.referenceName +
                            " - " +
                            stock.sku.quantity
                      }
                    />
                  </p>
                </Col>

                <Col
                  xs="12"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                  }}
                >
                  <p>
                    {"Product Price: " +
                      "₹" +
                      stock.sku.maximumRetailPrice}
                  </p>
                  <p>
                    <Input
                      style={{
                        padding: 10,
                        marginRight: 10,
                      }}
                      value={this.state.price}
                      placeholder="Enter price"
                      onChange={this.handlePriceChange}
                    />
                  </p>
                </Col>
                <Col
                  xs="12"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                  }}
                >
                  <p> {"Discounted Price: ₹" + stock.salePrice}</p>

                  <Input
                    style={{
                      padding: 10,
                      marginRight: 10,
                    }}
                    value={this.state.salePrice}
                    placeholder="Enter discounted price"
                    onChange={this.handleSalePriceChange}
                  />
                </Col>
                <Col
                  xs="12"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                  }}
                >
                  <p> {"Description: "}</p>

                  <Input
                    style={{
                      padding: 10,
                      marginRight: 10,
                    }}
                    value={this.state.description}
                    placeholder="Enter description"
                    onChange={this.handleDescriptionChange}
                  />
                </Col>
                <Col
                  xs="12"
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "column",
                  }}
                >
                  <p> {"Comments: "}</p>

                  <Input
                    style={{
                      padding: 10,
                      marginRight: 10,
                    }}
                    value={this.state.comments}
                    placeholder="Enter comments"
                    onChange={this.handleCommentsChange}
                  />
                </Col>
                <Row
                  className="justify-content-center"
                  style={{ marginTop: 12 }}
                >
                  <Button
                    style={{
                      backgroundColor: "#ff5500",
                      color: "white",
                      padding: 10,
                    }}
                    onClick={() => {
                      this.updateCartItemPrice();
                
                    }}
                  >
                    {"Save"}
                  </Button>
                </Row>
              </div>
            </div>
          </ModalBody>
        </Container>
      </LoadingOverlay>
    );
  }
  handlePriceChange = (event) => {
    this.setState({ price: event.target.value });
  };
  handleSalePriceChange = (event) => {
    this.setState({ salePrice: event.target.value });
  };
  handleDescriptionChange = (event) => {
    this.setState({ description: event.target.value });
  };
  handleCommentsChange = (event) => {
    this.setState({ comments: event.target.value });
  };

  toggleErrorTokenMissModal = (text) => {
    this.setState({
      tokenMissmatchModalVisible: !this.state.tokenMissmatchModalVisible,
      tokenErrorMessage: text,
    });
  };

  updatePrice = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let stock = this.props.stock;
    let price = this.state.price;
    let sale = 0;
    if (this.state.salePrice.length > 0) {
      sale = this.state.salePrice;
     }else{
       sale = this.state.price;
     }
    let params = {
      input: {
        id: stock.id,
        settlementPrice: parseFloat(sale),
        price: parseFloat(price),
        salePrice: parseFloat(sale),
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateStock",
      params
    );
    if (response.error === null) {
      this.updateSkuPrice();
      console.log("updateStock", JSON.stringify(response));
    } else {
      this.setState({ spinnerLoading: false });
      alert(
        "1 Unable to update inventory. Please check your internet connection."
      );
    }
  };
  updateSkuPrice = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let stock = this.props.stock;
    let price = this.state.price;
    let params = {
      input: {
        id: stock.sku.id,
        description: this.state.description,
        maximumRetailPrice: parseFloat(price),
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateSku",
      params
    );
    if (response.error === null) {
      this.updateCartItemPrice();
      this.setState({ spinnerLoading: false });
      console.log("updateSku", JSON.stringify(response));

      //this.props.refreshInventory();
      this.props.goBack();
    } else {
      this.setState({ spinnerLoading: false });
      alert(response.error);
      alert(
        "2 Unable to update inventory. Please check your internet connection."
      );
    }
  };
  updateCartItemPrice = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let sale = 0;
    if (this.state.salePrice.length > 0) {
      sale = this.state.salePrice;
     }else{
       sale = this.state.price;
     }
    let params = {
      input: {
        id:this.props.cartItem,
        unitprice: parseFloat(sale)
      },
    };

    console.log("params", JSON.stringify(params));
    let response = await requestManager.getResponseFromPredefinedQuery(
      "UpdateCartItemFulfilmentPrice",
      params
    );
    if (response.error === null) {
      //this.updateSkuPrice();
      console.log("UpdateCartItemFulfilmentPrice", JSON.stringify(response));
      this.setState({ spinnerLoading: false });
      this.props.goBack();
      //window.location.reload(false);
    } else {
      this.setState({ spinnerLoading: false });
      alert("Unable to update inventory. Please check your internet connection.");
      this.props.goBack();
      //);
    }
  };

}



// WEBPACK FOOTER //
// ./src/components/StockCartItemPrice/StockCartItemPrice.js